import card from '../de/card.json';
import common from '../de/common.json';
import credit from '../de/credit.json';
import input from '../de/input.json';

const translation = (
  {
    ...card,
    ...common,
    ...credit,
    ...input,
  }
)

export default translation;